module.exports = __webpack_public_path__ + "img/betalte-erfaringer-1.50163218.png";